import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    // 静态页面
    {
        path: '/license',
        name: 'License',
        component: () => import(/* webpackChunkName: "static" */ '../views/License.vue'),
    },
    {
        path: '/agree',
        component: () => import(/* webpackChunkName: "static" */ '../views/NewAgreement'),
    },
    {
        path: '/awarded',
        name: 'Awarded',
        component: () => import(/* webpackChunkName: "static" */ '../views/Awarded')
    },
    // 绑定
    {
        name: "NewBind",
        path: '/newBind/:openid/:type',
        component: () => import(/* webpackChunkName: "bind" */ '../views/NewBind')
    },
    // H5 模块
    {
        name: "TransProPrice",
        path: "/h5/transProPrice",
        component: () => import(/* webpackChunkName: "h5" */ '../views/H5/TransProPrice')
    },
    {
        name: "TransProTime",
        path: "/h5/transProTime",
        component: () => import(/* webpackChunkName: "h5" */ '../views/H5/TransProTime')
    },
    {
        name: "TransProStep",
        path: '/h5/trans-pro-step/:documentId',
        component: () => import(/* webpackChunkName: "h5" */ '../views/H5/TransProStep')
    },
    {
        path: '/h5/login',
        name: 'H5Login',
        component: () => import(/* webpackChunkName: "h5-auth" */ '../views/H5/Login')
    },
    {
        path: '/h5/register',
        name: 'H5Register',
        component: () => import(/* webpackChunkName: "h5-auth" */ '../views/H5/Register')
    },
    {
        name: "Pass",
        path: "/h5/resetPassword",
        component: () => import(/* webpackChunkName: "h5-auth" */ '../views/H5/Pass')
    },
    {
        path: '/h5/index',
        redirect: "/h5/index",
        component: () => import(/* webpackChunkName: "h5" */ '../views/H5/Index'),
        children: [
            {
                name: "Main",
                path: '/h5/index',
                component: () => import(/* webpackChunkName: "h5" */ '../views/H5/Main')
            },
            {
                name: "Trans",
                path: '/h5/trans',
                component: () => import(/* webpackChunkName: "h5" */ '../views/H5/Trans')
            },
            {
                name: "TransPro",
                path: '/h5/trans-pro',
                component: () => import(/* webpackChunkName: "h5" */ '../views/H5/TransPro')
            },
            {
                name: "TransDoc",
                path: '/h5/trans-doc',
                component: () => import(/* webpackChunkName: "h5" */ '../views/H5/TransDoc')
            },
            {
                name: "TransPolish",
                path: '/h5/trans-polish',
                component: () => import(/* webpackChunkName: "h5" */ '../views/H5/TransPolish')
            },
            {
                name: "Convert",
                path: '/h5/convert',
                component: () => import(/* webpackChunkName: "h5" */ '../views/H5/Convert')
            },
            {
                name: "List",
                path: '/h5/list',
                component: () => import(/* webpackChunkName: "h5" */ '../views/H5/List')
            }
        ],
    },
    // 错误页
    {
        path: '/error',
        name: 'Error',
        component: () => import(/* webpackChunkName: "error" */ '../components/Error')
    },
    // PC 认证模块
    {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "auth" */ '../components/Login')
    },
    {
        path: '/loginTwo',
        name: 'LoginTwo',
        component: () => import(/* webpackChunkName: "auth" */ '../components/LoginTwo')
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import(/* webpackChunkName: "auth" */ '../components/Register')
    },
    {
        path: '/registerTwo',
        name: 'RegisterTwo',
        component: () => import(/* webpackChunkName: "auth" */ '../components/RegisterTwo')
    },
    {
        path: '/recommendations',
        name: 'Recommendations',
        component: () => import(/* webpackChunkName: "auth" */ '../components/Recommendations')
    },
    {
        path: '/resetPassword',
        name: 'ResetPassword',
        component: () => import(/* webpackChunkName: "auth" */ '../components/ResetPassword')
    },
    {
        path: '/resetPasswordTwo',
        name: 'ResetPasswordTwo',
        component: () => import(/* webpackChunkName: "auth" */ '../components/ResetPasswordTwo')
    },
    {
        path: '/try',
        name: 'TryOut',
        component: () => import(/* webpackChunkName: "auth" */ '../components/TryOut')
    },
    // 首页
    {
        path: '/',
        redirect: "/index"
    },
    {
        path: '/index',
        component: () => import(/* webpackChunkName: "index" */ '../views/HomeLanding'),
    },
    {
        path: '/partners',
        name: 'Partners',
        component: () => import(/* webpackChunkName: "index" */ '../views/Partners'),
        meta: { public: true },
    },
    {
        path: '/about',
        name: 'ProductAdvantages',
        component: () => import(/* webpackChunkName: "index" */ '../views/ProductAdvantages'),
        meta: { public: true },
    },
    // 核心业务 - 翻译上传
    {
        path: '/translate',
        name: 'NewUpload',
        component: () => import(/* webpackChunkName: "upload" */ '../views/NewUpload'),
    },
    {
        path: '/rag',
        name: 'RagIndex',
        component: () => import(/* webpackChunkName: "rag" */ '../views/RagIndex'),
    },
    {
        path: '/smart-classify',
        name: 'SmartClassify',
        component: () => import(/* webpackChunkName: "smart-classify" */ '../views/SmartClassify'),
    },
    {
        path: '/extract',
        name: 'MaterialExtract',
        component: () => import(/* webpackChunkName: "material-extract" */ '../views/MaterialExtract'),
        meta: { public: true },
    },
    {
        path: '/scholar',
        name: 'ScholarSearch',
        component: () => import(/* webpackChunkName: "scholar" */ '../views/ScholarSearch'),
    },
    {
        path: '/category-tool',
        name: 'CategoryTool',
        component: () => import(/* webpackChunkName: "category-tool" */ '../views/CategoryToolServer'),
        meta: { public: true },
    },
    {
        path: '/scholar/saved',
        name: 'ScholarSavedWorks',
        component: () => import(/* webpackChunkName: "scholar" */ '../views/ScholarSavedWorks'),
    },
    {
        path: '/scholar/detail',
        name: 'ScholarWorkDetail',
        component: () => import(/* webpackChunkName: "scholar" */ '../views/ScholarWorkDetail'),
    },
    {
        path: '/scholar/entity',
        name: 'ScholarEntityDetail',
        component: () => import(/* webpackChunkName: "scholar" */ '../views/ScholarEntityDetail'),
    },
    {
        path: '/convert',
        redirect: "/translate",
        component: () => import(/* webpackChunkName: "upload" */ '../views/NewConvert'),
    },
    // 核心业务 - 文件列表
    {
        path: '/list',
        component: () => import(/* webpackChunkName: "list" */ '../views/ListPro'),
    },
    {
        path: '/list-pro',
        component: () => import(/* webpackChunkName: "list" */ '../views/ListPro'),
    },
    // 核心业务 - PDF 查看
    {
        path: '/read/:documentId',
        name: 'NewRead',
        component: () => import(/* webpackChunkName: "pdf" */ '../views/NewRead'),
    },
    {
        name: "DocView",
        path: '/docView/:documentId',
        redirect: to => ({ name: 'PdfPreview', params: { documentId: to.params.documentId } })
    },
    {
        name: "PdfPreview",
        path: '/pdfView/:documentId',
        component: () => import(/* webpackChunkName: "pdf" */ '../views/PdfPreview/Index.vue')
    },
    // 核心业务 - 图片翻译查看（与 PDF 阅读页相互独立）
    {
        name: 'ImagePreview',
        path: '/imageView/:documentId',
        component: () => import(/* webpackChunkName: "image-preview" */ '../views/ImagePreview/Index.vue')
    },
    // 详情页
    {
        path: '/detail/:documentId',
        name: 'Detail',
        component: () => import(/* webpackChunkName: "detail" */ '../views/Detail'),
    },
    // 旧版组件
    {
        path: '/*',
        redirect: "/list",
        component: () => import(/* webpackChunkName: "legacy" */ '../components/Index'),
        children: [
            {
                name: "Bind",
                path: '/bind/:openid/:type',
                component: () => import(/* webpackChunkName: "legacy" */ '../components/Bind')
            }, {
                path: "/list",
                component: () => import(/* webpackChunkName: "legacy" */ '../components/FileList')
            }, {
                path: '/agreement',
                component: () => import(/* webpackChunkName: "legacy" */ '../components/Agreement')
            }, {
                path: '/payTip',
                component: () => import(/* webpackChunkName: "legacy" */ '../components/PayTip')
            }, {
                path: '/help',
                name: 'Help',
                component: () => import(/* webpackChunkName: "legacy" */ '../components/Help')
            },
        ]
    },
]

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return { selector: to.hash };
        }
        return {
            x: 0,
            y: 0
        }
    }
})
router.beforeEach((to, from, next) => {
    const compactAuthRoutes = {
        '/login': '/h5/login',
        '/register': '/h5/register',
        '/resetPassword': '/h5/resetPassword',
    }
    const isCompactViewport = typeof window !== 'undefined' && (window.matchMedia
        ? window.matchMedia('(max-width: 768px)').matches
        : window.innerWidth <= 768)
    if (isCompactViewport && compactAuthRoutes[to.path]) {
        next({
            path: compactAuthRoutes[to.path],
            query: to.query,
            hash: to.hash,
            replace: true,
        })
        return
    }
    if (to.matched.some(record => record.meta && record.meta.public)) {
        next();
        return;
    }
    if (to.path ==='/agree'||to.name === 'Detail' || to.path === '/h5/transProTime' || to.path === '/h5/transProPrice' || to.path === '/h5/resetPassword' || to.path === '/h5/convert' || to.path === '/h5/trans-polish' || to.path === '/h5/trans-doc' || to.path === '/h5/trans-pro' || to.path === '/h5/trans' || to.path === '/h5/register' || to.path === '/h5/login' || to.path === "/h5/main" || to.path === "/h5/index" || to.path === "/awarded" || to.path === "/convert" || to.path === "/translate" || to.path === "/rag" || to.path === "/smart-classify" || to.path === "/scholar" || to.path === "/scholar/saved" || to.path === "/scholar/detail" || to.path === "/scholar/entity" || to.path === '/category-tool' || to.path === '/login' || to.path === '/resetPassword' ||
        to.name === 'NewBind' || to.path === '/index' || to.path === '/try' || to.path === '/register' || to.path === '/registerTwo' || to.path === '/loginTwo' || to.path === '/resetPasswordTwo'
        || to.path.startsWith('/bind') || to.path === '/agreement' || to.path === '/recommendations' || to.path === '/payTip' || to.path === '/help' || to.path === '/license') {
        next();
        return;
    }
    if (to.path !=='/agree'&&to.name !== 'Detail' && to.name !== '/NewBind' && to.path !== '/h5/transProTime' && to.path !== '/h5/transProPrice' && to.path !== '/h5/resetPassword' && to.path !== '/h5/convert' && to.path !== '/h5/trans-polish' && to.path !== '/h5/trans-doc' && to.path !== '/h5/trans-pro' && to.path !== '/h5/trans' && to.path !== '/h5/register' && to.path !== '/h5/login' && to.path !== "/h5/main" && to.path !== "/h5/index" && to.path !== "/awarded" && to.path !== "/convert" && to.path !== "/translate" && to.path !== "/smart-classify" && to.path !== "/scholar" && to.path !== "/scholar/saved" && to.path !== "/scholar/detail" && to.path !== '/login' && to.path !== '/resetPassword' &&
        to.path !== '/register' && to.path !== '/loginTwo' && to.path !== '/resetPasswordTwo' &&
        to.path !== '/registerTwo' && to.path !== '/agreement' && to.path !== '/recommendations'
        && !to.path.startsWith('/bind') && to.path !== '/try' && to.path !== '/payTip' && to.path !== '/help' && to.path!=='/license'
        && !localStorage.getItem('token') && !localStorage.getItem('auth-context')) {
        if (to.path.indexOf('/h5/') > -1) {
            next("/h5/login");
            return;
        }
        next("/index");
        return;
    }
    next();
})
router.afterEach((to) => {
    if (typeof window !== 'undefined' && window.WiseIvyViewport) {
        window.WiseIvyViewport.sync(to.path)
    }
})
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default router
